export const ROLE_GROUPS = {
  superadmin: ['superadmin'],
  admin: ['workspace_admin', 'hr_admin', 'admin', 'superadmin'],
  manager: ['manager', 'hr_manager'],
  employee: ['employee'],
};

export const normalizeRole = (role) => {
  if (!role) return 'employee';
  return String(role).toLowerCase();
};

export const hasAnyRole = (role, allowedRoles = []) => {
  const normalized = normalizeRole(role);
  return allowedRoles.map(normalizeRole).includes(normalized);
};

export const getHomeRouteByRole = (role) => {
  const normalized = normalizeRole(role);
  if (ROLE_GROUPS.superadmin.includes(normalized)) return '/superadmin';
  if (ROLE_GROUPS.admin.includes(normalized)) return '/admin';
  if (ROLE_GROUPS.manager.includes(normalized)) return '/manager';
  return '/dashboard';
};
